let messengerId = new Date().getTime().toString() + '.' + 'documents-server';
export class FrameUtils {
	static notify(message: FrameMessageTypes, data: any = {}, options: INotifyOptions) {
		options = options ?? <INotifyOptions>{};
		options.domain = options.domain ?? '*';
		const payload = Object.assign(data || {}, {
			_messageType: message,
			_destination: options.destinationId,
			_originId: messengerId
		});
		const destinations = [];
		if (options.window) {
			destinations.push(options.window);
		} else {
			try {
				window.parent && destinations.push(window.parent);
			} catch (_) {}

			try {
				window.opener && destinations.push(window.opener);
			} catch (_) {}

			for (let i = 0; i < window.frames.length; i++) {
				try {
					const d = window.frames[i];
					d && destinations.push(d);
				} catch (_) {
					// do nothing
				}
			}
		}
		for (let i = 0; i < destinations.length; i++) {
			if (destinations[i] == window) continue;

			try {
				destinations[i].postMessage(JSON.stringify(payload), options.domain);
			} catch (err) {
				console.error(err);
			}
		}
	}
}

export type FrameMessageTypes = 'splitit-learnmore-close' | 'splitit-generic-popup-trigger-close';

export interface INotifyOptions {
	domain?: string;
	destinationId?: string;
	window?: Window;
}

export const COMMON_MESSAGES: { [key: string]: FrameMessageTypes } = {
	LEARNMORE_CLOSED: 'splitit-learnmore-close',
	GENERIC_POPUP_TRIGGER_CLOSE: 'splitit-generic-popup-trigger-close'
} as const;
